import departmentUsersCommitTypes from './commit-types';
import ReducerUtilities from "../../../shared/store/reducer-utilities";
import userModel from "../../../subscriber-app/models/user";

const INITIAL_DEPARTMENT_USERS_STATE = {
  list: [],
  isLoading: [],
  isEditingRoles: null
};

function departmentUsersReducers(state = INITIAL_DEPARTMENT_USERS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case departmentUsersCommitTypes.SET_USERS_FOR_DEPARTMENT:
      return {
        ...state,
        list: [...action.users.map(item => userModel(item))]
      };
    case departmentUsersCommitTypes.SET_USERS_FOR_DEPARTMENT_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    case departmentUsersCommitTypes.SET_EDIT_ROLES_FOR_USER:
      return {
        ...state,
        isEditingRoles: state.list.find(({guid}) => action.userId === guid)
      };
    case departmentUsersCommitTypes.UPDATE_USER_FOR_DEPARTMENT:
      return {
        ...state,
        isEditingRoles: userModel(action.user),
        list: state.list.map(user =>
          user.guid === action.user.guid
            ? userModel(action.user)
            : user
        )
      };
    default:
      return state;
  }
}

export default departmentUsersReducers;